import { useLocale } from '../LocaleContext.tsx';

/**
 * The one place the mark is referenced (§3).
 *
 * The supplied PNG is palette-mode with no alpha channel — it carries a solid
 * white background and cannot sit on the green. Until the vector original
 * arrives, this renders the generated placeholder; swapping it is editing the
 * `src` on the next line and nothing else.
 */
const LOGO_SRC = '/brand/logo-placeholder.svg';

export function Brand({ className }: { className?: string }) {
  const { t } = useLocale();
  return (
    <a
      className={`brand ${className ?? ''}`.trim()}
      href="/"
      aria-label={t('brand.alt')}
    >
      <img
        className="brand__img"
        src={LOGO_SRC}
        alt={t('brand.alt')}
        width={132}
        height={32}
      />
    </a>
  );
}
